<template>
  <div class="container">
    <section class="article-search">
      <div class="search-wapper">
        <h3><span>—</span> 学科资讯 <span>—</span></h3>
        <div class="searchLeft flex">
          <div class="inputDiv flex">
            <el-input v-model="keyword" clearable @keyup.enter.native="toSearch" placeholder="请输入资讯关键词"></el-input>
            <div @click="toSearch" class="search-btn">搜索</div>
          </div>
        </div>
      </div>
    </section>

    <div class="w1200 wapper">
      <!-- 学科分类 -->
      <div class="subject_wapper">
        <span>学科分类</span>
        <div class="subject_list">
          <div class="subject-item" @click="handChangeSubject(index)" :class="{ 'is-active': subjectIndex == index }" v-for="(item, index) in subjectList" :key="index">{{ item.name }}</div>
        </div>
        <div class="more" @click="showMore">
          <span v-if="!moreFlag">更多<i class="el-icon-arrow-down"></i></span>
          <span v-else>收起<i class="el-icon-arrow-up"></i></span>
        </div>
      </div>
      <!-- 资讯列表 -->
      <ul class="news_list">
        <li v-for="(item, index) in list" :key="index">
          <p class="title" @click="toDetail(item.sid)"><img v-if="index < 5 && pageNo == 1" src="../../assets/images/img_tag_xin.svg" /><span class="line1" v-html="item.title"></span></p>
          <div class="news-ai" v-if="item.alDigest">
            <p><img src="../../assets/images/ainews2.png" alt="" /></p>
            <!-- <p class="news-ai-text">{{ item.alDigest }}<label>展开</label></p> -->
            <p class="news-ai-text" v-if="!item.open">
              <span v-html="capitalize(item.alDigest)"></span>
              <label class="digestLabel" v-if="item.alDigest.length > 310" @click="showDigest(index)">展开</label>
            </p>
            <p class="news-ai-text" v-if="item.open">
              <span v-html="item.alDigest"></span>
              <label class="digestLabel" @click="closeDigest(index)">收起</label>
            </p>
          </div>
          <div class="news-bottom">
            <span>{{ item.author }}</span>
            <span></span>
            <span>{{ item.publishTime }}</span>
            <div class="flex" :class="{ checked: item.share }" @click="toNewsCollect(item)" v-if="info && !info.ipUser">
              <img class="img" :src="item.share ? collectTrue : collectFalse" />
              <img class="hover-img" src="../../assets/images/icon-sc-xz.png" />收藏
              <i class="share" v-if="item.shareCount > 0">{{ item.shareCount }}</i>
            </div>
          </div>
        </li>
      </ul>
      <div class="noData" v-if="total <= 0">
        <img src="../../assets/images/noData.png" />
      </div>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo" :page-sizes="[10, 20, 30, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" hide-on-single-page> </el-pagination>
    </div>
  </div>
</template>

<script>
import baseurl from "../../api/baseurl";
export default {
  data() {
    return {
      subjectList: [],
      subjectListAll: [],
      keyword: "",
      subjectIndex: 0,
      moreFlag: false,
      info: {},
      pageNo: 1,
      pageSize: 10,
      subjectCode: "",
      total: 0,
      list: [],

      collectFalse: require("../../assets/images/icon-sc-mr.png"),
      collectTrue: require("../../assets/images/icon-sc-xz.png"),
    };
  },
  mounted() {
    this.getInfo();
    this.getSubjectList();
    this.getList();
  },
  methods: {
    getInfo() {
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then(res => {
        this.info = res.data;
      });
    },
    getSubjectList() {
      this.$http({
        url: "api/v1/subject/brochure/first/list",
        method: "get",
      }).then(res => {
        this.subjectListAll = res.data;
        this.subjectList = this.subjectListAll.slice(0, 14);
      });
    },
    handChangeSubject(index) {
      this.subjectIndex = index;
      this.subjectCode = this.subjectList[index].code;
      this.pageNo = 1;
      this.getList();
    },
    showMore() {
      this.moreFlag = !this.moreFlag;
      if (this.moreFlag) {
        this.subjectList = this.subjectListAll;
      } else {
        this.subjectList = this.subjectListAll.slice(0, 14);
      }
    },
    getList() {
      let postBody = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        subjectCode: this.subjectCode,
        searchWord: this.keyword,
      };
      this.$http({
        url: "api/v1/subject/brochure/list",
        method: "post",
        data: postBody,
      }).then(res => {
        this.list = res.data.recordList;
        this.total = res.data.recordCount;
      });
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      this.getList();
    },
    toSearch() {
      this.pageNo = 1;
      this.getList();
    },
    toDetail(sid) {
      this.$http({
        url: "api/v1/subject/brochure/sys/url?sid=" + sid,
        method: "get",
      }).then(res => {
        window.open(baseurl.localUrl + res.data);
      });
    },
    // 摘要展开
    showDigest(index) {
      this.list[index].open = true;
      this.$forceUpdate();
    },
    closeDigest(index) {
      this.list[index].open = false;
      this.$forceUpdate();
    },
    // 收藏
    toNewsCollect(item) {
      let postBody = {
        outSid: item.sid,
        type: 4,
      };
      this.$http({
        url: "api/v1/usershare/collect",
        method: "post",
        data: postBody,
      }).then(res => {
        if (!item.share) {
          this.$message.success("收藏成功");
        }
        this.getList();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-width: calc(100vw);
  min-height: calc(100vh - 160px);
  .article-search {
    width: 100%;
    height: 240px;
    background: url("../../assets/images/search_bg.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    .search-wapper {
      width: 1200px;
      margin: 0 auto;
      position: relative;
    }
    h3 {
      text-align: center;
      font-weight: normal;
      font-size: 26px;
      font-family: "宋体";
      span {
        color: #cccccc;
      }
    }
    .searchLeft {
      border: 1px solid #cccccc;
      width: 840px;
      height: 48px;
      background: #fff;
      margin: 0 auto;
      margin-top: 30px;
      position: relative;
      ::v-deep .el-input__inner {
        border: none;
        height: 48px;
        background: none;
        border-radius: 0;
      }

      .inputDiv {
        align-items: center;
        flex: 1;
        background: #fff;
        ::v-deep .el-input {
          flex: 1;
        }

        .search-btn {
          cursor: pointer;
          margin-right: 4px;
          width: 80px;
          height: 40px;
          background: #2d8cf0;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
        }
      }
    }
  }
  .wapper {
    background: #fff;
    margin-top: 20px;
    margin-bottom: 20px;
    .subject_wapper {
      padding: 20px 20px 10px 20px;
      display: flex;
      line-height: 30px;
      color: #636870;
      font-size: 15px;
      align-items: baseline;
      .subject_list {
        flex: 1;
        column-gap: 8px;
        transition: all 0.3s;
        margin-left: 20px;
        display: flex;
        flex-wrap: wrap;
        .subject-item {
          height: 30px;
          margin-bottom: 10px;
          padding: 6px 10px;
          font-weight: 400;
          font-size: 15px;
          line-height: 20px;
          background-color: #fff;
          border-radius: 4px;
          cursor: pointer;
          color: #333;
          &:hover {
            color: #2d8cf0;
          }
        }
        .is-active {
          background: #f2f3f5;
          font-weight: bold;
          color: #2d8cf0;
        }
      }
      .more {
        margin-left: 30px;
        cursor: pointer;
        display: flex;
        align-items: center;
        color: #636870;
        i {
          margin-left: 3px;
          font-size: 16px;
          vertical-align: -1px;
        }
      }
    }
    .news_list {
      border-top: 10px solid #f7f7f7;
      padding: 20px;
      font-size: 15px;
      li {
        border-bottom: 1px solid #eee;
        padding: 20px 0;
        &:nth-of-type(1) {
          padding-top: 0;
        }
        &:last-of-type {
          border: none;
          padding-bottom: 0;
        }
        .title {
          display: flex;
          align-items: center;
          font-weight: bold;
          font-size: 17px;
          cursor: pointer;
          &:hover {
            background-image: linear-gradient(to right, #006eb3, #2d8cf0);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
          img {
            margin-right: 10px;
          }
        }
        .news-ai {
          background: #f7f8fa;
          padding: 20px;
          margin-top: 15px;
          img {
            width: 80px;
          }
          .news-ai-text {
            color: #636870;
            line-height: 25px;
            .digestLabel {
              color: #2d8cf0;
              cursor: pointer;
              margin-left: 3px;
            }
          }
        }
        .news-bottom {
          margin-top: 15px;
          display: flex;
          align-items: center;
          span {
            margin-right: 20px;
            color: #636870;
            &:nth-of-type(2) {
              height: 10px;
              width: 1px;
              display: inline-block;
              background: #ddd;
            }
          }
          .checked {
            color: #2d8cf0;
          }
          .flex {
            align-items: center;
            margin-left: 30px;
            cursor: pointer;
            position: relative;
            margin-left: auto;
            img {
              margin-right: 2px;
              width: 15px;
            }
            .share {
              font-style: normal;
              color: #2d8cf0;
              margin-left: 2px;
            }
            &:hover {
              color: #2d8cf0;
              .hover-img {
                display: inline-block;
              }
              .img {
                display: none;
              }
            }

            .hover-img {
              display: none;
            }
          }
        }
      }
    }
  }
}
</style>
